export const regex = new RegExp('^[^<>"\';]*$')
